// Shared game constants

/** @typedef {'str' | 'dex' | 'con' | 'int' | 'wis' | 'cha'} AbilityKey */

/** @type {{[key: string]: string}} */
export const ABILITY_NAMES = {
  str: 'Strength',
  dex: 'Dexterity',
  con: 'Constitution',
  int: 'Intelligence',
  wis: 'Wisdom',
  cha: 'Charisma',
};

/** @type {Array<AbilityKey>} */
export const ABILITY_ORDER = ['str', 'dex', 'con', 'int', 'wis', 'cha'];

/** @type {{[key: string]: string}} Skill slug to ability mapping (D&D 5e SRD) */
export const SKILL_ABILITIES = {
  acrobatics: 'dex',
  'animal-handling': 'wis',
  arcana: 'int',
  athletics: 'str',
  deception: 'cha',
  history: 'int',
  insight: 'wis',
  intimidation: 'cha',
  investigation: 'int',
  medicine: 'wis',
  nature: 'int',
  perception: 'wis',
  performance: 'cha',
  persuasion: 'cha',
  religion: 'int',
  'sleight-of-hand': 'dex',
  stealth: 'dex',
  survival: 'wis',
};

/** All skill slugs */
export const ALL_SKILLS = Object.keys(SKILL_ABILITIES);

/** @type {string[]} */
export const FANTASY_FIRST_NAMES = [
  'Achilles',
  'Adonis',
  'Aelric',
  'Ajax',
  'Alaric',
  'Aldric',
  'Andromeda',
  'Apollo',
  'Ares',
  'Aria',
  'Ariadne',
  'Artemis',
  'Astrid',
  'Athena',
  'Atlas',
  'Aurora',
  'Avalon',
  'Bjorn',
  'Boris',
  'Branwen',
  'Brigid',
  'Brynhild',
  'Callista',
  'Cassius',
  'Cassandra',
  'Cato',
  'Cedric',
  'Celeste',
  'Ceres',
  'Ciara',
  'Circe',
  'Corvus',
  'Cyrus',
  'Daphne',
  'Darius',
  'Decimus',
  'Diana',
  'Dmitri',
  'Draven',
  'Eamon',
  'Edric',
  'Elara',
  'Elektra',
  'Elena',
  'Ember',
  'Eris',
  'Evander',
  'Farid',
  'Felix',
  'Fenrir',
  'Fiora',
  'Freya',
  'Galahad',
  'Gideon',
  'Griffin',
  'Guinevere',
  'Gunnar',
  'Hadrian',
  'Hassan',
  'Hector',
  'Helena',
  'Helios',
  'Idris',
  'Igor',
  'Ingrid',
  'Iris',
  'Isolde',
  'Ivan',
  'Jasper',
  'Kael',
  'Kaladin',
  'Katya',
  'Khalid',
  'Leander',
  'Leonidas',
  'Liora',
  'Lucian',
  'Luna',
  'Lyra',
  'Magnus',
  'Malik',
  'Maren',
  'Maximus',
  'Medea',
  'Mira',
  'Morgan',
  'Nadia',
  'Nyx',
  'Octavia',
  'Odin',
  'Ophelia',
  'Orion',
  'Percival',
  'Perseus',
  'Phoenix',
  'Ragnar',
  'Raven',
  'Remus',
  'Roland',
  'Rowan',
  'Sable',
  'Sasha',
  'Seraphina',
  'Sienna',
  'Sigrid',
  'Solara',
  'Sorin',
  'Stellan',
  'Talon',
  'Thalia',
  'Theron',
  'Titania',
  'Tristan',
  'Ulric',
  'Valerius',
  'Vesper',
  'Viktor',
  'Vladislav',
  'Wren',
  'Xander',
  'Yara',
  'Zara',
  'Zephyr',
  'Zinnia',
  'Sven',
  'Rune',
  'Saga',
  'Torsten',
];
